import { siteApiSlice } from "../../app/siteApiSlice";

export interface LlmFeedbackCommentRequestModel {
	llmFeedbackId: number;
	scoreCategoryId: number;
}

export interface LlmFeedbackCommentViewModel {
	llmFeedbackId: number;
	scoreCategoryId: number;
	isReadonly: boolean;
	wasHelpful: boolean;
	comment: string;
	authorRole: string;
}

export const llmFeedbacktApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getLlmFeedbackComment: build.query<
			LlmFeedbackCommentViewModel,
			LlmFeedbackCommentRequestModel
		>({
			query: (request) => ({
				url: `/LlmFeedback/FeedbackComment`,
				method: "GET",
				params: request,
			}),
			providesTags: ["FeedbackComment"],
		}),
		saveLlmFeedbackComment: build.mutation<void, LlmFeedbackCommentViewModel>({
			query: (model) => ({
				url: `/LlmFeedback/FeedbackComment`,
				method: "POST",
				body: model,
			}),
			invalidatesTags: ["FeedbackComment"],
		}),
		deleteLlmFeedbackComment: build.mutation<void, LlmFeedbackCommentViewModel>({
			query: (model) => ({
				url: `/LlmFeedback/DeleteFeedbackComment`,
				method: "POST",
				body: model,
			}),
			invalidatesTags: ["FeedbackComment"],
		}),
	}),
});

export const {
	useLazyGetLlmFeedbackCommentQuery,
	useSaveLlmFeedbackCommentMutation,
	useDeleteLlmFeedbackCommentMutation,
} = llmFeedbacktApiSlice;
